module.exports = __webpack_public_path__ + "59479ccaac0561551798e596b722ae03.svg";